import React from 'react';
import styled from 'styled-components';
import Countdown, { zeroPad } from 'react-countdown';
import { _ } from '_locales';
import SecondsCounter from './SecondsCounter';

const Container = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: 'column';
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  background: transparent;
`;

const ModalImages = styled.div`
  display: flex;
  text-align: center;
  justify-content: space-between;
`;

/**
 * This component shows a 5 seconds count down timer before starting of the game
 * wrong or correct asnwers.
 *
 */

// Renderer callback with condition
const renderer = ({ seconds }) => <SecondsCounter seconds={zeroPad(seconds)} isBeforeGame />;

const CountDownModal = () => (
  <Container>
    <ModalContent>
      <ModalImages>
        <Countdown date={Date.now() + 5000} renderer={renderer} />
      </ModalImages>
    </ModalContent>
  </Container>
);

export default CountDownModal;
